var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 750,
    height: 766,
    viewBox: "0 0 750 766",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M478.202 346.018V271.418",
    stroke: "white",
    strokeWidth: 3.8781,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2626 132.647L71.4224 101.227",
    stroke: "white",
    strokeWidth: 0.775621,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.075 156.56L65.2421 151.329",
    stroke: "white",
    strokeWidth: 0.775621,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M302.796 444.844L479.638 344.112",
    stroke: "white",
    strokeWidth: 3.8781,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M276.516 231.639V157.039",
    stroke: "white",
    strokeWidth: 3.8781,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3947 161.725L16.3947 7.42578",
    stroke: "white",
    strokeWidth: 1.65026,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.11 330.464L277.96 229.732",
    stroke: "white",
    strokeWidth: 3.8781,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2626 111.063L71.4224 79.6416",
    stroke: "white",
    strokeWidth: 0.775621,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2626 89.956L71.4224 58.5352",
    stroke: "white",
    strokeWidth: 0.775621,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2626 68.7744L71.4224 37.3535",
    stroke: "white",
    strokeWidth: 0.775621,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0826 127.499L95.1526 169.102",
    stroke: "white",
    strokeWidth: 0.775621,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7809 92.8193L89.4185 116.938",
    stroke: "white",
    strokeWidth: 0.775621,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79529 70.21L27.1299 84.0639",
    stroke: "white",
    strokeWidth: 0.775621,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M467.385 567.92L707.638 710.543",
    stroke: "white",
    strokeWidth: 3.8781,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M454.043 574.595L694.296 717.218",
    stroke: "white",
    strokeWidth: 3.8781,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2467 169.102C12.1953 169.102 8.90307 165.842 8.87831 161.808C8.85356 157.773 12.1211 154.489 16.1725 154.464C20.3229 154.447 23.6811 157.756 23.6399 161.824C23.5904 165.859 20.2981 169.102 16.2467 169.102Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M479.631 277.31C475.579 277.31 472.287 274.05 472.262 270.016C472.237 265.981 475.505 262.697 479.556 262.672C483.707 262.655 487.065 265.964 487.024 270.032C486.974 274.067 483.682 277.31 479.631 277.31Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M277.945 162.939C273.893 162.939 270.601 159.679 270.576 155.644C270.552 151.61 273.819 148.326 277.87 148.301C282.021 148.284 285.379 151.593 285.338 155.661C285.288 159.696 281.996 162.939 277.945 162.939Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3862 9.90155C13.6688 9.90155 11.4605 7.69687 11.4439 4.96754C11.4273 2.2382 13.619 0.016786 16.3364 4.15761e-05C19.1203 -0.0111213 21.3728 2.22703 21.3451 4.97869C21.3119 7.70803 19.1037 9.90155 16.3862 9.90155Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4145 38.9122C69.6652 38.9122 68.2378 37.5013 68.2295 35.752C68.2213 34.011 69.6322 32.5835 71.3815 32.5752C73.1803 32.567 74.6325 34.0027 74.6078 35.7602C74.5913 37.5095 73.1638 38.9122 71.4063 38.9122H71.4145Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4145 61.6456C69.6652 61.6456 68.2378 60.2347 68.2295 58.4854C68.2213 56.7444 69.6322 55.3169 71.3815 55.3086C73.1803 55.3004 74.6325 56.7361 74.6078 58.4936C74.5913 60.2429 73.1638 61.6456 71.4063 61.6456H71.4145Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4145 82.8107C69.6652 82.8107 68.2378 81.3997 68.2295 79.6504C68.2213 77.9094 69.6322 76.4819 71.3815 76.4737C73.1803 76.4654 74.6325 77.9011 74.6078 79.6587C74.5913 81.4079 73.1638 82.8107 71.4063 82.8107H71.4145Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4145 104.395C69.6652 104.395 68.2378 102.984 68.2295 101.234C68.2213 99.4934 69.6322 98.0659 71.3815 98.0577C73.1803 98.0494 74.6325 99.4851 74.6078 101.243C74.5913 102.992 73.1638 104.395 71.4063 104.395H71.4145Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9887 172.262C93.2395 172.262 91.812 170.851 91.8037 169.102C91.7955 167.361 93.2065 165.933 94.9557 165.925C96.7545 165.917 98.2067 167.352 98.182 169.11C98.1655 170.859 96.738 172.262 94.9805 172.262H94.9887Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2361 120.106C88.4868 120.106 87.0593 118.695 87.0511 116.945C87.0428 115.204 88.4538 113.777 90.203 113.769C92.0018 113.76 93.4541 115.196 93.4293 116.954C93.4128 118.703 91.9853 120.106 90.2278 120.106H90.2361Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M3.18503 73.378C1.43576 73.378 0.00828729 71.9671 3.6006e-05 70.2178C-0.00821528 68.4768 1.40275 67.0493 3.15203 67.0411C4.95081 67.0328 6.40304 68.4685 6.37828 70.226C6.36178 71.9753 4.93431 73.378 3.17679 73.378H3.18503Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0674 159.72C54.3181 159.72 52.8906 158.309 52.8824 156.56C52.8741 154.819 54.2851 153.391 56.0343 153.383C57.8331 153.375 59.2854 154.81 59.2606 156.568C59.2441 158.317 57.8166 159.72 56.0591 159.72H56.0674Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M243.181 608.764C239.13 608.764 235.838 605.505 235.813 601.47C235.788 597.435 239.056 594.151 243.107 594.126C247.257 594.11 250.616 597.418 250.574 601.486C250.525 605.521 247.233 608.764 243.181 608.764Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M243.198 602.633V702.169L489.763 553.72L16.2626 279.546V163.888",
    stroke: "white",
    strokeWidth: 3.8781,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M676.762 748.508C646.81 748.508 622.444 723.944 622.27 693.579C622.097 663.214 646.273 638.46 676.242 638.303C706.962 638.147 731.815 663.082 731.468 693.694C731.121 724.1 706.755 748.516 676.762 748.508Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 10.9907,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M618.433 703.266H601.707V681.54H618.433",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M626.89 659.5L615.19 647.552L630.711 632.354L642.411 644.301",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M664.409 635.91V619.185H686.143V635.91",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M732.516 703.266H749.241V681.54H732.516",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M724.058 659.5L735.758 647.552L720.238 632.354L708.537 644.301",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M618.433 681.91H601.707V703.636H618.433",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M626.89 725.676L615.19 737.632L630.711 752.831L642.411 740.875",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M664.409 749.274V766H686.143V749.274",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M732.516 681.91H749.241V703.636H732.516",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M724.058 725.676L735.758 737.632L720.238 752.831L708.537 740.875",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M676.852 734.431C699.514 734.431 717.885 716.059 717.885 693.397C717.885 670.735 699.514 652.363 676.852 652.363C654.189 652.363 635.818 670.735 635.818 693.397C635.818 716.059 654.189 734.431 676.852 734.431Z",
    fill: "#716558",
    stroke: "white",
    strokeWidth: 1.26245,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.ff4468afd8bfa4f80524bbd6783fa626.svg";
export { ForwardRef as ReactComponent };